import React from 'react'
import { useSelector } from 'react-redux'
import { ReactComponent as PhoneIcon } from 'assets/svg/settings/phone.svg'
import { useTranslation } from 'react-i18next'

export const UserNumbers = () => {
    const { extension_number, domain_name } = useSelector((state) => state.profile.data)
    const { t } = useTranslation()

    return (
        <div className="account__numbers">
            <span className="account__title">{t('extensions_domain')}</span>
            <div className="account__numbers__item account__white-box d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <PhoneIcon />
                    <span className="account__numbers__item-number">{extension_number}</span>
                    <span>{domain_name}</span>
                </div>
            </div>
        </div>
    )
}
